<div class="dialog">
  <h2 mat-dialog-title class="dialog-title">{{ variables?.confirmInitialCostTitle }}</h2>
  <mat-dialog-content>
    <p class="message">
      {{ variables?.confirmInitialCostBefore }}&nbsp;<strong>{{ data.amount | currency:'EUR':'symbol':'1.2-2' }}</strong>{{ variables?.confirmInitialCostAfter }}
    </p>
  </mat-dialog-content>
  <div class="dialog-box-s">
    <mat-dialog-actions class="button-group">
      <app-button typeBtn="secondary" color="red" textColor="white" message="{{ variables?.cancel }}" (click)="cancel()"></app-button>
      <app-button typeBtn="primary" message="{{ variables?.confirmInitialCostConfirm }}" (click)="confirm()"></app-button>
    </mat-dialog-actions>
  </div>
</div>
